import React from "react";
import { thStyle, tHeadStyle } from '../styles';

export const TableHeader = ({ }) => (
  <tr style={tHeadStyle}>
    <th style={thStyle}>Incident Type</th>
    <th style={thStyle}>Location</th>
    <th style={thStyle}>Submitted By</th>
    <th style={thStyle}>Incident detail</th>
    <th style={thStyle}>Incident Date</th>
  </tr>
)